import type { FC } from "react";

import { Grid, Loader } from "src/components";

export const LoadingAuth: FC = () => (
    <Grid justifyContent="center" alignItems="center" gridTemplateRows="100vh">
        <Loader size={40} />
    </Grid>
);
